/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { chatList } from "../funcs/chatList.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListChatsResult } from "../models/components/listchatsresult.js";
import {
  AccountType,
  HasRisk,
  ListChatsRequest,
  ListChatsSecurity,
  Pinned,
  SortBy,
  SortOrder,
} from "../models/operations/listchats.js";
import { unwrapAsync } from "../types/fp.js";
export type ListChatsQueryData = ListChatsResult;

export function prefetchListChats(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListChatsRequest | undefined,
  security?: ListChatsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildListChatsQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildListChatsQuery(
  client$: GramCore,
  request?: ListChatsRequest | undefined,
  security?: ListChatsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<ListChatsQueryData>;
} {
  return {
    queryKey: queryKeyListChats({
      search: request?.search,
      externalUserId: request?.externalUserId,
      userId: request?.userId,
      source: request?.source,
      assistantId: request?.assistantId,
      agentId: request?.agentId,
      sourceKind: request?.sourceKind,
      excludeSourceKind: request?.excludeSourceKind,
      hasRisk: request?.hasRisk,
      accountType: request?.accountType,
      pinned: request?.pinned,
      minRiskScore: request?.minRiskScore,
      from: request?.from,
      to: request?.to,
      limit: request?.limit,
      offset: request?.offset,
      sortBy: request?.sortBy,
      sortOrder: request?.sortOrder,
      gramSession: request?.gramSession,
      gramProject: request?.gramProject,
      gramChatSession: request?.gramChatSession,
    }),
    queryFn: async function listChatsQueryFn(ctx): Promise<ListChatsQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(chatList(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyListChats(
  parameters: {
    search?: string | undefined;
    externalUserId?: string | undefined;
    userId?: string | undefined;
    source?: string | undefined;
    assistantId?: string | undefined;
    agentId?: string | undefined;
    sourceKind?: string | undefined;
    excludeSourceKind?: string | undefined;
    hasRisk?: HasRisk | undefined;
    accountType?: AccountType | undefined;
    pinned?: Pinned | undefined;
    minRiskScore?: number | undefined;
    from?: Date | undefined;
    to?: Date | undefined;
    limit?: number | undefined;
    offset?: number | undefined;
    sortBy?: SortBy | undefined;
    sortOrder?: SortOrder | undefined;
    gramSession?: string | undefined;
    gramProject?: string | undefined;
    gramChatSession?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "chat", "list", parameters];
}
